<div class="container" [ngStyle]="{'width': appServiceScreenDesktop ? '80%' : '100%'}">
    <div style="text-align: center;padding: 50px;">
        <img alt="chatfoto" ngSrc="../../../../assets/img/notfound.webp" width="192" height="150">
        <p style="font-size: 20px;font-weight: 700;">{{'email_verify' | translate}} {{text}}!</p>
    </div>
</div>